export enum PushNotificationType {
  SUCCESS_NEW_ORDERS = 'APNS_SUCCESS_NEW_ORDERS',
  ORDER_SHIPPED = 'APNS_ORDER_SHIPPED',
  REWARDS_BADGE = 'APNS_REWARD_BADGE',
}

export type PushConnectionAcknowledgement = {
  userId: string;
  memberId: string | null;
  status: string;
};

export type OrderPushNotificationData = {
  orderId?: string;
  type: PushNotificationType.SUCCESS_NEW_ORDERS | PushNotificationType.ORDER_SHIPPED;
};

export type RewardsBadgePushNotificationData = {
  'badge-id': string;
  'icon-url'?: string;
  points: number;
  type: PushNotificationType.REWARDS_BADGE;
};

export type OrderPushNotificationEnvelope = {
  body?: string;
  data: OrderPushNotificationData;
  title?: string;
};

export type RewardsBadgePushNotificationEnvelope = {
  body: string;
  data: RewardsBadgePushNotificationData;
  title: string;
};

export type PushNotificationEnvelope =
  | OrderPushNotificationEnvelope
  | RewardsBadgePushNotificationEnvelope;

export type PushNotificationEvent = {
  event: string;
  id: string;
  notification: PushNotificationEnvelope;
};

export type PushNotificationMessage = PushConnectionAcknowledgement | PushNotificationEnvelope;

export type PushNotificationStreamError = Error & {
  status?: number;
  body?: string;
};
